export const currentAppVersion = '2.0'; // Update this value to force a reload of the app
